import { getVehicleDocCountList } from '_services';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { LuCircleCheckBig } from 'react-icons/lu';
import { FaRegClock } from 'react-icons/fa6';
import { FiDownload } from 'react-icons/fi';
import { PiWarningCircle } from 'react-icons/pi';
import { MdOutlineCancel } from 'react-icons/md';
import { GrDocumentText } from 'react-icons/gr';
import StorageService from 'utils/StorageServices/StorageServices';
import { utils } from 'helper';
import { API, AppConfig } from 'lib';
import toast from 'react-hot-toast';

const DocumentOverview = ({ setRedirectFilterDetails }) => {

    const loadingBarRef = useRef(null);
    const [documentCountList, setDocumentCountList] = useState([]);
    const [activeOwnership, setActiveOwnership] = useState("1");
    const [loading, setLoading] = useState(false);
    let isToken = localStorage.getItem("token");

    const activeData = documentCountList?.[activeOwnership];

    // Fetch Count API
    const getVehicleDocList = async () => {
        try {
            loadingBarRef.current?.continuousStart();

            let object = {
                company_id: StorageService.getCompanyId(),
            };

            const res = await getVehicleDocCountList(object);

            if (res?.responseCode === 200) {
                setDocumentCountList(res?.data?.ownership_wise_count);
            }

        } finally {
            loadingBarRef.current?.complete();
        }
    };

    useEffect(() => {
        getVehicleDocList();
    }, []);



    const fetchVehicleDocs = async (activeOwnership) => {

        setLoading(true)
        try {
            const payload = {
                company_id: StorageService.getCompanyId(),
                vehicle_ownership: activeOwnership
            }
            const response = await fetch(`${AppConfig.api_baseurl}${API.EXPORT_VEHICLE_DOCUMENT_SUMMARY}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Token': `${isToken}`,
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                const errorBody = await response.json().catch(() => ({}));
                if (errorBody?.responseMessage) {
                    toast.error(errorBody?.responseMessage);
                }
                throw new Error(`Server Error (${errorBody?.responseMessage})`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `vehicle_Document.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }

    };



    return (
        <>
            {/* Ownership Tabs */}
            <div className='__trcVl_topFilts'>
                {Object.entries(documentCountList || {})
                    .filter(([key]) => key !== 'unmatched')
                    .map(([key, item]) => (
                        <div
                            key={key}
                            className={`__trvl_flt ${activeOwnership === key ? "__trvlActive" : ""}`}
                            onClick={() => setActiveOwnership(key)}
                        >
                            <p>{item.name}</p>
                            <h2>{item.total_vehicles}</h2>
                        </div>
                    ))}
            </div>

            {/* Table */}
            <div className='__docView_table'>
                <div className='__docViw_head'>
                    <h4>Document Overview</h4>

                    <button className='anime-btn __exptBtn' onClick={()=>fetchVehicleDocs(activeOwnership)}>
                        <FiDownload />
                        Export
                    </button>
                </div>

                <table className='__docOv_table'>
                    <thead>
                        <tr>
                            <th><span className='__docType_th'>Document Type</span></th>

                            <th><span className='__docAdd_th'><LuCircleCheckBig /><div>Added</div></span></th>

                            <th><span className='__docNotAdd_th'><FaRegClock /> <div>Not Added</div></span></th>

                            <th><span className='__docNrExp_th'><PiWarningCircle /> <div>Near Expiry</div></span></th>

                            <th><span className='__docExp_th'><MdOutlineCancel /> <div>Expired</div></span></th>
                        </tr>
                    </thead>

                    <tbody>
                        {documentCountList?.[activeOwnership]?.documents?.map((doc, i) => (
                            <tr key={i}>
                                <td>
                                    <span className="__docFit">
                                        <GrDocumentText />
                                        <div className="__dcTxt">{doc.name}</div>
                                    </span>
                                </td>

                                <td>
                                    <span
                                        className="__docAdd_td __clickable"
                                        onClick={() =>
                                            setRedirectFilterDetails({
                                                activeTab: 2,
                                                activeStatus: 3,
                                                activeOwnershipNw: activeOwnership,
                                                doc_type_id: doc.doc_type_id
                                            })
                                        }
                                    >
                                        <LuCircleCheckBig />
                                        <div className="__dcTxt">{doc.Added}</div>
                                    </span>
                                </td>

                                <td>
                                    <span
                                        className="__docNotAdd_td __clickable"
                                        onClick={() =>
                                            setRedirectFilterDetails({
                                                activeTab: 2,
                                                activeStatus: 4,
                                                activeOwnershipNw: activeOwnership,
                                                doc_type_id: doc.doc_type_id
                                            })
                                        }
                                    >
                                        <FaRegClock />
                                        <div className="__dcTxt">{doc["Not Added"]}</div>
                                    </span>
                                </td>

                                <td>
                                    <span
                                        className="__docNrExp_td __clickable"
                                        onClick={() =>
                                            setRedirectFilterDetails({
                                                activeTab: 2,
                                                activeStatus: 2,
                                                activeOwnershipNw: activeOwnership,
                                                doc_type_id: doc.doc_type_id
                                            })
                                        }
                                    >
                                        <PiWarningCircle />
                                        <div className="__dcTxt">{doc["Near Expiry"]}</div>
                                    </span>
                                </td>

                                <td>
                                    <span
                                        className="__docExp_td __clickable"
                                        onClick={() =>
                                            setRedirectFilterDetails({
                                                activeTab: 2,
                                                activeStatus: 1,
                                                activeOwnershipNw: activeOwnership,
                                                doc_type_id: doc.doc_type_id
                                            })
                                        }
                                    >
                                        <MdOutlineCancel />
                                        <div className="__dcTxt">{doc.Expired}</div>
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>


                <div className='__docViw_foot'>
                    <div className='__dcFr_txt'>
                        Total {activeData?.total_vehicles} {activeData?.name}
                    </div>

                    <div className='__dcLas_txt'>
                        <div className='__dcSerp __dcAdd'><span></span> {utils.getTotalAmount(documentCountList?.[activeOwnership]?.documents, 'Added')} Added</div>
                        <div className='__dcSerp __dcNotAdd'><span></span> {utils.getTotalAmount(documentCountList?.[activeOwnership]?.documents, 'Not Added')} Not Added</div>
                        <div className='__dcSerp __dcNearExp'><span></span> {utils.getTotalAmount(documentCountList?.[activeOwnership]?.documents, 'Near Expiry')} Near Expiry</div>
                        <div className='__dcSerp __dcExp'><span></span> {utils.getTotalAmount(documentCountList?.[activeOwnership]?.documents, 'Expired')} Expired</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default DocumentOverview;